"use client";
import { styled } from "@mui/material/styles";
import { SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
const PillBadgesContainer = styled("ul")({
  display: "flex",
  flexFlow: "wrap",
  gap: SpaceXxs,
  height: "max-content",
  margin: `0 0 ${SpaceXxs} 0`,
  padding: 0,
  width: "100%"
});
export {
  PillBadgesContainer
};
